module.exports = __webpack_public_path__ + "img/app2.e0f0db41.png";